module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_8.ca8ee917.jpg";